import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend, Title);

const DonutChart = ({ chartData, chartOptions, height, width }) => {
  if (!chartData?.datasets?.[0]?.data?.length) {
    return null;
  }

  return (
    <div style={{ position: 'relative', height: height ?? 300, width: width ?? '100%' }}>
      <Doughnut
        data={chartData}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          ...chartOptions,
        }}
      />
    </div>
  );
};

export default DonutChart;
